import CheckIcon from '@mui/icons-material/Check'
import { Button, ButtonProps } from '@mui/material'
import { SystemStyleObject, Theme } from '@mui/system'
import React from 'react'
import CustomPalette from '../../../theme/CustomPalette'
import { composeSx } from '../../../utils/composeSx'

interface CustomButtonProps extends Omit<ButtonProps, 'sx'> {
  children: React.ReactNode
  height?: string
  width?: string
  fontWeight?: number | string
  sx?: SystemStyleObject<Theme>
  isMenuOpen?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  withCheckIcon?: boolean
}

export const CancelButtonStyle = {
  backgroundColor: 'transparent',
  color: CustomPalette.PilotBlue,
  fontSize: '16px',
  fontWeight: 400,
  '&:hover': {
    backgroundColor: 'transparent',
  },
}

const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  height,
  width,
  fontWeight,
  isMenuOpen,
  onClick,
  withCheckIcon = false,
  sx: callerSx,
  ...props
}) => (
  <Button
    data-testid="custom-button"
    onClick={onClick}
    type="submit"
    startIcon={withCheckIcon ? <CheckIcon /> : undefined}
    {...props}
    sx={composeSx(
      {
        pl: '24px',
        pr: '24px',
        height: height ? height : '40px',
        width: width && width,
        backgroundColor: props.disabled ? CustomPalette.SecondaryNightBlue50 : CustomPalette.PilotBlue,
        color: props.disabled ? CustomPalette.DisableGray : '#fff',
        border: '1px solid transparent',
        borderRadius: !isMenuOpen ? '20px' : isMenuOpen ? '20px 20px 0px 0px' : '30px',
        transition: '0.5s ease',
        '&:hover': {
          backgroundColor: CustomPalette.SecondaryCloud,
          color: CustomPalette.PilotBlue,
          borderColor: CustomPalette.PilotBlue,
          transition: ' 0.5s ease',
        },
        '&:disabled': {
          backgroundColor: CustomPalette.SecondaryNightBlue50,
          color: CustomPalette.SecondaryNightBlue400,
        },
        textTransform: 'none',
        fontSize: 16,
        fontWeight: fontWeight ?? '450',
      },
      callerSx,
    )}>
    {children}
  </Button>
)

export default CustomButton
